import { render, staticRenderFns } from "./PanelSubsection.vue?vue&type=template&id=95de4256&scoped=true"
import script from "./PanelSubsection.vue?vue&type=script&lang=ts"
export * from "./PanelSubsection.vue?vue&type=script&lang=ts"
import style0 from "./PanelSubsection.vue?vue&type=style&index=0&id=95de4256&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95de4256",
  null
  
)

export default component.exports